<template>
  <div>
    <div class="top">
      <div class="l">
        <select v-model="secondGuess[0]" @change="calcBottoms"><option v-for="opt in 25">{{opt}}</option></select>C<sub>2</sub>H<sub>6</sub> <sub>(g)</sub> + 
        <select v-model="secondGuess[1]" @change="calcBottoms"><option v-for="opt in 25">{{opt}}</option></select>O<sub>2</sub> <sub>(g)</sub>         

        <div class="bottom">
          <span>C=<span>{{ bottom0 }}</span></span>
          <span>H=<span>{{ bottom1 }}</span></span>
          <span>O=<span>{{ bottom2 }}</span></span>
        </div>

      </div>

      <div class="a">
        &xrarr; 
      </div>

      <div class="r">
        <select v-model="secondGuess[2]" @change="calcBottoms"><option v-for="opt in 25">{{opt}}</option></select>CO<sub>2</sub> <sub>(g)</sub> + 
        <select v-model="secondGuess[3]" @change="calcBottoms"><option v-for="opt in 25">{{opt}}</option></select>H<sub>2</sub>O <sub>(g)</sub>         
        
        <div class="bottom">
          <span>C=<span>{{ bottom3 }}</span></span>
          <span>H=<span>{{ bottom4 }}</span></span>
          <span>O=<span>{{ bottom5 }}</span></span>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Equation9',
  data: function () {
    return {
      bottom0: 2,
      bottom1: 6,
      bottom2: 2,
      bottom3: 1,
      bottom4: 2,
      bottom5: 3
    }
  },
  props: ['secondGuess'],
  watch: {
    secondGuess: {
      handler: function (val) {
        this.calcBottoms(false, true)
      },
      deep: true
    }
  },
  methods: {
    calcBottoms: function (event, skip = false) {
      this.bottom0 = (parseInt(this.secondGuess[0]) || 1) * 2
      this.bottom1 = (parseInt(this.secondGuess[0]) || 1) * 6
      this.bottom2 = (parseInt(this.secondGuess[1]) || 1) * 2
      this.bottom3 = (parseInt(this.secondGuess[2]) || 1) * 1
      this.bottom4 = (parseInt(this.secondGuess[3]) || 1) * 2
      // co2+ h2o in the formula, so o gets added twice (bottom5 = the last O in the subtext helper)
      this.bottom5 = ((parseInt(this.secondGuess[2]) || 1) * 2) + ((parseInt(this.secondGuess[3]) || 1) * 1)

      if (skip !== false) {
        // also emit the change for the parent
        this.$emit('setSecond', this.secondGuess)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// Equation9.vue?5762d711